import { createAction, props } from '@ngrx/store';
import { CreditCardTokenResponse, InvoiceResponse, PaymentResponseModel, PaymentSession, ProcessTextToPayRequest } from './payment.state';

export const clearState = createAction('[Payment] clear payment state');
export const clearContractState = createAction('[ContractTreatment] clear Contract Treatment State');

export const invokeInvoiceResponse = createAction('[Payment] invoke text to pay details',props<{ encodedString: string }>());
export const setInvoiceResponse = createAction('[Payment] set invoice response',props<{ invoiceResponse: InvoiceResponse }>());

export const invokePaymentSession = createAction('[Payment] invoke payment session',props<{ encodedString: string }>());
export const setPaymentSession = createAction('[Payment] Set payment session',props<{ paymentSession: PaymentSession }>());
export const clearPaymentSession = createAction('[Payment] clear payment session');

export const creditCardTokenSuccess = createAction('[Payment] credit card token success',props<{ patientCreditCardToken: string }>());
export const setCreditCardTokenResponse = createAction('[Payment] credit card token success',props<{ result: CreditCardTokenResponse }>());
export const clearTokenResponse = createAction('[Payment] Clear credit card token');

export const setPaymentRequest = createAction('[Payment] set payment request',props<{ paymentRequestModel: ProcessTextToPayRequest }>());
export const invokePayment = createAction('[Payment] invokePayment',props<{ paymentRequestModel: ProcessTextToPayRequest }>());
export const paymentSuccess = createAction('[Payment] payment success', props<{ paymentResponse: PaymentResponseModel }>());

export const startCreditCardLoading = createAction('[Payment] credit card section loading start');
export const stopCreditCardLoading = createAction('[Payment] credit card section loading stop');

export const closeErrorAlert = createAction('[Payment] close error alert');
export const closeSuccessAlert = createAction('[Payment] close success alert');

export const paymentFailure = createAction('[Payment] Payment failure',  props<{ errorMessage: string }>());

export const setPaymentToken = createAction('[Payment] set payment token',props<{ encodedString: string }>());

export const startPaymentLoading = createAction('[Payment] payment loading');
export const startSessionLoading = createAction('[Payment] payment loading');
